function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { CustomModal } from 'seagull';
import { withStoreActions } from "../../store/store-context";
import GenericError from "../GenericError/GenericError";
import { isSentryIgnoredError } from "./sentryIgnoredError";
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundaryPage extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname || prevProps.location.search !== this.props.location.search) {
      this.setState({
        hasError: false
      });
    }
  }
  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error(error);
    if (!isSentryIgnoredError(error)) {
      Sentry.withScope(scope => {
        scope.setContext('Error data', error instanceof Error ? {
          message: error.message,
          stack: error.stack
        } : {
          rawError: JSON.stringify(error)
        });
        Sentry.captureException('ErrorBoundaryPage caught an error');
      });
      this.props.actions.logBI(18300);
    }
  }
  render() {
    const {
      bounded,
      isModal,
      children,
      dismissModal
    } = this.props;
    const {
      hasError
    } = this.state;
    const errorPage = /*#__PURE__*/_jsx(GenericError, {
      fullPage: !bounded && !isModal,
      testId: "error-boundary-page"
    });
    return hasError ? isModal ? /*#__PURE__*/_jsx(CustomModal, {
      onClose: dismissModal,
      children: errorPage
    }) : errorPage : children;
  }
}
export default withRouter(withStoreActions(ErrorBoundaryPage));